export default __webpack_public_path__ + "resources/icons/n310-47f8.webp";